import { createSelector } from "reselect";

import { IStore } from "@soft/redux/reducers";

const getNavigationStateFunction = (store: IStore) => store.navigation;

export const getNavigationState = createSelector(
  [getNavigationStateFunction],
  f => f,
);
